import * as React from 'react';
import classnames from 'classnames';

const Chip = ({ className , children , href , onClick  })=>{
    return /*#__PURE__*/ React.createElement("a", {
        href: href,
        className: classnames('chip', className),
        onClick: onClick
    }, children);
};

export { Chip };
//# sourceMappingURL=Chip.js.map
